import { Component } from "@angular/core";

export const ruleSetToExclude = ['lw_manager_fields_logic_ruleset', 'response_fields_logic_mandatory_ruleset', 'lw_manager_fields_logic_ruleset']
export const categorySchema = {
    title: 'Add Category',
    type: 'object',
    schema_type: "category",
    properties: {
        name: {
            label: 'Name',
            type: "string",
            required: true,
            minLength: 3
        },
        levels: {
            label: 'Set Level Based Visibility',
            type: 'table',
            widget: 'checkbox-table',
            columns: [{
                label: 'Organisation Levels',
                key: 'label',
                type: "label"
            }, {
                label: 'Visibility',
                key: 'visible',
                type: "checkbox"
            }],
            errorMessages: {
                required: 'Please select at least one organisation level'
            }
        }
    }
};

export const subCategorySchema = {
    title: 'Add Sub-category',
    type: 'object',
    schema_type: "sub_category",
    properties: {
        name: {
            label: 'Name',
            type: 'string',
            required: true,
            minLength: 3
        }
    }
};

export const categoryRuleSchema = {
    title: 'Add New Rule',
    type: 'object',
    schema_type: "category_rule",
    basic: {
        properties: {
            name: {
                label: 'Name',
                type: 'string',
                description: 'The name of the rule',
                required: true,
                minLength: 3,
                maxLength: 50
            },
            category_list: {
                label: 'Applies To',
                type: 'list',
                component: 'multi-select',
                options: [], // Will be populated dynamically from categoryList
                textField: 'name', // Field name to display in the dropdown
                uniqueIdField: 'uuid', // Field name for unique identification
                placeholder: 'Select categories',
                required: true,
                errorMessages: {
                    required: 'Please select at least one category'
                }
            },
            description: {
                label: 'Description',
                placeholder: 'Description',
                type: 'string',
                multiline: true,
                required: false,
                widget: 'textarea',
                maxLength: 1000
            }
        }
    },
    conditions: {
        properties: {
            rulesetlist: [],
            rulesetHash: {},
            fieldDefsMap: {},
            dataObject: {
                "disabled": false,
                "ruleset_id": "",
                "field_id": "",
                "field_id_value": "",
                "operator_id": "",
                "value": "",
                "value_type": "",
                "join_id": "",
                "editing": true,
                "unique_id": ""
            }
        }
    },
    sections: [
        {
            name: 'Basic',
            type: "basic"
        },
        {
            name: 'Conditions',
            type: "conditions"
        }
    ]
};

export const subCategoryDefaultValues = {
    name: ''
};

export const ruleDefaultValues = {
    name: '',
    description: ''
};

export const categoryDefaultValues = {
    name: '',
    organisationLevels: {}
};


// Action Status Schema
// Status modal schema
export const statusSchema = {
    title: 'Add Status',
    type: 'object',
    schema_type: "status",
    properties: {
        name: {
            label: 'Name',
            type: 'string',
            required: true,
            showLabel: true,
            placeholder: 'Status Name',
            maxLength: 50,
            errorMsg: 'Status Name is mandatory.'
        },
        levels: {
            label: 'Access Levels',
            type: 'table',
            required: false,
            showLabel: false,
            columns: [
                {
                    label: 'Organisation Levels',
                    key: 'label',
                    type: "label"
                },
                {
                    label: 'Visibility',
                    key: 'visible',
                    type: "checkbox"
                }
            ],
            errorMsg: 'Access level is mandatory.'
        },
        color: {
            label: 'Color',
            type: 'string',
            component: 'color',
            required: false,
            showLabel: true,
            errorMsg: 'Color is mandatory.'
        },
        out_of_sequence: {
            label: 'Out of Sequence Status',
            type: 'boolean',
            component: 'switch',
            required: false,
            showLabel: true
        },
        exclude_from_ageing: {
            label: 'Exclude from Ageing',
            type: 'boolean',
            component: 'switch',
            required: false,
            showLabel: true
        },
        trigger_for: {
            label: 'Apply same status to',
            type: 'array',
            component: 'checkbox-group',
            required: false,
            showLabel: true,
            options: [
                { name: 'Parent', id: 'parent' },
                { name: 'Siblings', id: 'siblings' },
                { name: 'Children', id: 'children' }
            ],
            errorMsg: 'Apply same status for is mandatory.'
        },
        hide_slaTimer_for_status: {
            label: 'Hide for SLA Timer',
            type: 'boolean',
            component: 'switch',
            required: false,
            showLabel: true
        }
    }
};

// Rule modal schema
export const statusRuleSchema = {
    title: 'Add Rule',
    type: 'object',
    schema_type: "status_rule",
    basic: {
        properties: {
            name: {
                label: 'Name',
                type: 'string',
                required: true,
                showLabel: true,
                placeholder: 'Rule Name',
                maxLength: 50,
                errorMsg: 'Name is mandatory.'
            },
            status_list: {
                label: 'Applies To',
                type: 'list',
                component: 'multi-select',
                options: [],
                textField: 'name',
                uniqueIdField: 'uuid',
                placeholder: 'Select Statuses this Rule applies to',
                required: true,
                errorMsg: 'Applies To is mandatory.'
            },
            description: {
                label: 'Description',
                type: 'string',
                required: false,
                showLabel: true,
                multiline: true,
                placeholder: 'Brief description',
                widget: 'textarea',
                maxLength: 1000,
                errorMsg: 'Description is mandatory.'
            },
        }
    },
    conditions: {
        properties: {
            rulesetlist: [],
            rulesetHash: {},
            fieldDefsMap: {},
            dataObject: {
                "disabled": false,
                "ruleset_id": "",
                "field_id": "",
                "field_id_value": "",
                "operator_id": "",
                "value": "",
                "value_type": "",
                "join_id": "",
                "editing": true,
                "unique_id": ""
            }
        }
    },
    sections: [
        {
            name: 'Basic',
            type: "basic"
        },
        {
            name: 'Conditions', // TODO: Add conditions section
            type: "conditions"
        }
    ]

};

export const workflowSchema = {
    title: 'Add Rule',
    type: 'object',
    schema_type: "workflow",
    basic: {
        properties: {
            name: {
                label: 'Name',
                type: 'string',
                required: true,
                showLabel: true,
                placeholder: 'Rule Name',
                maxLength: 50,
                errorMsg: 'Name is mandatory.'
            },
            event_name: {
                label: 'Event',
                type: 'string',
                component: 'dropdown',
                options: [],
                textField: 'text',
                valueField: 'id',
                placeholder: 'Select Event',
                required: true,
                errorMsg: 'Event is mandatory.',
                note: ''
            },
            description: {
                label: 'Description',
                type: 'string',
                required: false,
                showLabel: true,
                multiline: true,
                placeholder: 'Brief description',
                widget: 'textarea',
                maxLength: 1000,
                errorMsg: 'Description is mandatory.'
            },
            delay_time: {
                label: 'Delay in Minutes',
                type: 'number',
                required: false,
                showLabel: true,
                placeholder: 'Input delay in minutes',
                errorMsg: 'Delay in Minutes is mandatory.'
            }
        }
    },
    conditions: {
        properties: {
            rulesetlist: [],
            rulesetHash: {},
            fieldDefsMap: {},
            dataObject: {
                "disabled": false,
                "ruleset_id": "",
                "field_id": "",
                "field_id_value": "",
                "operator_id": "",
                "value": "",
                "value_type": "",
                "join_id": "",
                "editing": true,
                "unique_id": ""
            }
        }
    },
    actions: {
        properties: {
            actions: [],
            actionsHash: {},
            dataObject: {
                "disabled": false,
            }
        }
    },
    sections: [
        {
            name: 'Basic',
            type: "basic"
        },
        {
            name: 'Conditions', // TODO: Add conditions section
            type: "conditions"
        },
        {
            name: 'Actions', // TODO: Add actions section
            type: "actions"
        }
    ]

};

// Data Field Rule modal schema
export const dataFieldRuleSchema = {
    title: 'Add Rule',
    type: 'object',
    schema_type: "data_field_rule",
    basic: {
        properties: {
            uuid: {
                label: 'uuid',
                type: 'string',
                required: false,
                hidden: true,
                showLabel: false
            },
            created_date: {
                label: 'created_date',
                type: 'string',
                required: false,
                hidden: true,
                showLabel: false
            },
            is_enabled: {
                label: 'is_enabled',
                type: 'string',
                required: false,
                hidden: true,
                showLabel: false
            },
            ignore_for_ui_rule: {
                label: 'ignore_for_ui_rule',
                type: 'boolean',
                required: false,
                hidden: true,
                showLabel: false
            },
            name: {
                label: 'Name',
                type: 'string',
                required: true,
                showLabel: true,
                placeholder: 'Rule Name',
                maxLength: 50,
                errorMsg: 'Rule Name is required.'
            },
            type: {
                label: 'Rule Type',
                type: 'string',
                component: 'dropdown',
                options: [
                    { id: 'visibility', name: 'Visibility' },
                    { id: 'read-only', name: 'Editability' },
                    { id: 'mandatory', name: 'Mandatory' }
                ],
                textField: 'name',
                valueField: 'id',
                placeholder: 'Select Type of Rule',
                required: true,
                errorMsg: 'Rule Type is required.',
                disabled: false
            },
            event_name: {
                label: 'Event',
                type: 'string',
                component: 'dropdown',
                options: [],
                textField: 'name',
                valueField: '_id',
                placeholder: 'Select Event',
                required: false,
                showLabel: true,
                hidden: true,
                condition: {
                    parentField: "type",
                    operator: 'eq',
                    value: 'mandatory',
                    fieldToUpdate: 'hidden',
                    valueToSet: false
                }
            },
            applies_to: {
                label: 'Applies To',
                type: 'string',
                component: 'dropdown',
                options: [],
                textField: 'name',
                optionsMap: {},
                valueField: 'id',
                placeholder: 'Select Data Fields this Rule applies to',
                required: true,
                errorMsg: 'Applies To is required.',
                condition: {
                    parentField: "type",
                    fieldToUpdate: 'options'
                }
            },
            applies_to_child_field_ids: {
                label: 'Applies To Field',
                type: 'list',
                component: 'multi-select',
                options: [],
                textField: 'name',
                valueField: 'id',
                uniqueIdField: 'id',
                placeholder: 'Select Applies To Field',
                required: false,
                showLabel: true,
                hidden: true,
                condition: {
                    parentField: "applies_to",
                    operator: 'has_child',
                    fieldToUpdate: 'hidden',
                    valueToSet: false
                }
            },
            description: {
                label: 'Description',
                type: 'string',
                required: false,
                showLabel: true,
                multiline: true,
                placeholder: 'Brief description',
                widget: 'textarea',
                maxLength: 1000
            }
        }
    },
    conditions: {
        properties: {
            rulesetlist: [],
            rulesetHash: {},
            fieldDefsMap: {},
            dataObject: {
                "disabled": false,
                "ruleset_id": "",
                "field_id": "",
                "field_id_value": "",
                "operator_id": "",
                "value": "",
                "value_type": "",
                "join_id": "",
                "editing": true,
                "unique_id": ""
            }
        }
    },
    sections: [
        {
            name: 'Basic',
            type: "basic"
        },
        {
            name: 'Conditions',
            type: "conditions"
        }
    ]
};
